module.exports = __webpack_public_path__ + "static/media/statistics.a520e4b57ae97956781a38319ed6ce82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/features/statistics.png
// module id = 2506
// module chunks = 1